<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="90%"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">

            <Row>
                <Col span="24">
                    <div class="em-step">
                        <Steps :current="detail.step_id" size="small">
                            <Step title="暂停/取消"></Step>
                            <Step title="项目立项" ></Step>
                            <Step title="清单报价"></Step>
                            <Step title="合同签署"></Step>
                            <Step title="项目施工"></Step>
                            <Step title="项目验收"></Step>
                            <Step title="维保尾款"></Step>
                            <Step title="项目完成"></Step>
                        </Steps>
                    </div>
                    <Card :bordered="false" dis-hover>
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">项目信息</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                            <Description term="项目名称：">
                                {{detail.name}}
                            </Description>
                            <Description term="项目类型：">
                                <Tag>{{detail.type_name}}</Tag>
                            </Description>
                            <Description term="项目预算：">
                                {{detail.budget_money}}
                            </Description>
                            <Description term="项目周期：">
                                {{detail.project_cycle}}
                            </Description>
                            <Description term="甲方：">
                                <Tag>{{detail.company}}</Tag>
                            </Description>
                            <Description term="联系人：">
                                {{detail.customer_real_name}}
                            </Description>
                            <Description term="联系电话：">
                                {{detail.customer_mobile}}
                            </Description>
                            <Description term="微信账号：">
                                {{detail.customer_wechat}}
                            </Description>
                            <Description term="立项时间：">
                                {{detail.init_time}}
                            </Description>
                            <Description term="项目进度：">
                                <Badge v-if="detail.status === 1" color="blue" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 2" color="red" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 3" color="cyan" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 4" color="orange" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 5" color="red" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 6" color="purple" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 7" color="green" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 8" color="lime" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 9" color="volcano" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 10" color="red" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 11" color="blue" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 12" color="purple" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 13" color="pink" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 14" color="green" :text="detail.status_name" />
                                <Badge v-else color="#999999" :text="detail.status_name" />
                            </Description>
                            <Description term="负责人：">
                                {{detail.head_name}}
                            </Description>
                            <Description term="更新时间：">
                                {{detail.update_time}}
                            </Description>
                            <Description term="项目金额：">
                                <strong class="text-primary">{{detail.money??'0.00'}}</strong>
                            </Description>
                            <Description term="收款金额：">
                                <strong class="text-success">{{detail.collection_money??'0.00'}}</strong>
                            </Description>
                            <Description term="欠款金额：">
                                <strong class="text-danger">{{detail.debt_money??'0.00'}}</strong>
                            </Description>
                            <Description term="开票金额：">
                                <strong class="text-primary">{{detail.invoice_money??'0.00'}}</strong>
                            </Description>
                        </DescriptionList>
                        <div class="em-panel-box">
                            <Collapse accordion>
                                <Panel name="1">
                                    项目说明
                                    <template #content> <div class="textarea-wrap">{{detail.project_desc}}</div></template>
                                </Panel>
                            </Collapse>
                        </div>
                    </Card>
                    <Card :bordered="false" dis-hover v-if="detail.status > 3 || detail.return_status > 3">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">报价清单</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                            <Description term="报价金额：">
                                <strong class="text-primary">{{detail.quote_money??'0.00'}}</strong>
                            </Description>
                            <Description term="报价时间：">
                                {{detail.quote_time}}
                            </Description>
                            <Description v-if="detail.status > 5" term="审批人：">
                                {{detail.examine_name}}
                            </Description>
                            <Description v-if="detail.status > 5" term="审批时间：">
                                {{detail.examine_time}}
                            </Description>
                        </DescriptionList>
                        <div class="em-panel-box">
                            <a href="javascript:void(0);" @click="FileDownload(detail.project_file)" class="em-file-download">清单材料下载</a>
                            <Collapse accordion>
                                <Panel name="1">
                                    报价清单
                                    <template #content><div class="textarea-wrap">{{detail.quote_desc}}</div></template>
                                </Panel>
                            </Collapse>
                        </div>
                    </Card>
                    <Card :bordered="false" dis-hover v-if="detail.status > 6 || detail.return_status > 6">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">合同签署</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                            <Description term="合同金额：">
                                <strong class="text-primary">{{detail.contract_money??'0.00'}}</strong>
                            </Description>
                            <Description term="项目金额：">
                                <strong class="text-success">{{detail.money??'0.00'}}</strong>
                            </Description>
                            <Description term="合同资料：">
                                <a href="javascript:void(0);" @click="FileDownload(detail.contract_file)" class="em-file-download">点击下载</a>
                            </Description>
                            <Description term="合同有效期："  v-if="detail.status > 6">
                                {{detail.contract_start_time}} ~ {{detail.contract_end_time}}
                            </Description>
                            <Description term="签署时间：" v-if="detail.status > 6">
                                {{detail.contract_time}}
                            </Description>
                            <Description term="甲方签署人：" v-if="detail.status > 6">
                                {{detail.contract_signa_name}}
                            </Description>
                        </DescriptionList>
                    </Card>

                    <Card :bordered="false" dis-hover v-if="detail.status > 7 || detail.return_status > 7">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">项目施工</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                            <Description term="开工日期：">
                                {{detail.start_work_time}}
                            </Description>
                            <Description term="施工时长：">
                                {{detail.work_duration}}
                            </Description>
                            <Description term="完工时间：">
                                {{detail.work_expected_time}}
                            </Description>
                            <Description term="完工确认人：">
                                {{detail.work_true_name}}
                            </Description>
                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="!!detail.work_list">
                            <Description term="施工人员：">
                                <Tag v-for="(item,index) in detail.work_list" :key="index">{{item.real_name}}</Tag>
                            </Description>
                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="材料支出：">
                                <Table :stripe="true" border  size="small" :columns="columns" show-summary :summary-method="handleSummary" :data="detail.expendList" class="tables-x"    no-data-text="暂无数据记录">
                                    <template #sn="{ row }">
                                        <div class="d-width text-primary cursor" :title="row.sn" @click="showExpendData(row.expend_id)">
                                            <span>{{row.sn}}</span>
                                        </div>
                                    </template>
                                    <template #buyer_id="{ row }">
                                        <div class="d-width" :title="row.buyer_title">
                                            <span>{{row.buyer_title}}</span>
                                        </div>
                                    </template>
                                    <template #pay_time="{ row }">
                                        <span>{{!!row.pay_time?row.pay_time:'-'}}</span>
                                    </template>
                                    <template #company="{ row }">
                                        <div class="d-width" :title="row.company">
                                            <span>{{row.company}}</span>
                                        </div>
                                    </template>
                                    <template #type_id="{ row }">
                                        <Tag v-if="row.type_id === 1" color="blue">{{row.type_name}}</Tag>
                                        <Tag v-else-if="row.type_id === 2" color="orange">{{row.type_name}}</Tag>
                                        <Tag v-else-if="row.type_id === 3" color="green">{{row.type_name}}</Tag>
                                        <Tag v-else-if="row.type_id === 4" color="purple">{{row.type_name}}</Tag>
                                        <span v-else>-</span>
                                    </template>
                                    <template #status="{ row }">
                                        <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                        <Badge v-else-if="row.status === 3" color="orange" :text="row.status_name" />
                                        <Badge v-else-if="row.status === 5" color="green" :text="row.status_name" />
                                        <Poptip v-else-if="row.status === 4 || row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                            <Badge color="red" :text="row.status_name" />
                                            <template #content>
                                                <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                                <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                            </template>
                                        </Poptip>
                                        <Badge v-else color="#999999" text="其他" />
                                    </template>

                                    <template #remark="{ row }">
                                        <div class="d-width" :title="row.remark">
                                            <span>{{row.remark}}</span>
                                        </div>
                                    </template>
                                    <template #action="{ row }">
                                        <a class="text-font-sm text-success" @click="showExpendData(row.expend_id)">查看</a>
                                    </template>
                                </Table>
                            </Description>
                        </DescriptionList>
                    </Card>

                    <Card :bordered="false" dis-hover v-if="detail.status > 10 || detail.return_status > 10">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">项目验收</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                            <Description term="维保有效期：">
                                {{detail.protect_time}}
                            </Description>
                            <Description term="项目验收人：">
                                {{detail.acceptance_name}}
                            </Description>
                            <Description term="验收人电话：">
                                {{detail.acceptance_mobile}}
                            </Description>
                            <Description term="验收时间：">
                                {{detail.acceptance_true_time}}
                            </Description>
                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="">
                                <div class="uploads">
                                    <div class="upload-images" v-for="(item,index) in detail.acceptance_image" :key="index" @click.stop="">
                                        <img :src="site_url + item">
                                        <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                    </div>
                                </div>
                            </Description>
                        </DescriptionList>
                    </Card>

                    <Card :bordered="false" dis-hover v-if="detail.status > 11 || detail.return_status > 11">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">项目审计</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                            <Description term="最终审计项目金额：">
                                <strong class="text-success">{{detail.audit_money??'0.00'}}</strong>
                            </Description>
                            <Description term="审计人：">
                                {{detail.audit_name}}
                            </Description>
                            <Description term="审计时间：">
                                {{detail.audit_time}}
                            </Description>
                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="">
                                <Table :stripe="true" border  size="small" :columns="columns3" :data="detail.auditList" class="tables-x"  ref="selection"  no-data-text="暂无数据记录">
                                </Table>
                            </Description>
                        </DescriptionList>
                    </Card>

                    <Card :bordered="false" dis-hover v-if="detail.status > 13 || detail.return_status > 13">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">项目结束</strong></template>
                        <DescriptionList class="show-description-title" title=""  :col="3"  layout="vertical">
                            <Description term="结束时间：">
                                {{detail.success_time}}
                            </Description>
                            <Description term="确认人：">
                                {{detail.success_name}}
                            </Description>
                            <Description term="备注信息：">
                                {{detail.success_remark ?? '-'}}
                            </Description>
                        </DescriptionList>
                    </Card>

                    <Card :bordered="false" dis-hover>
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">收款记录</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="">
                                <Table :stripe="true" border  size="small" :columns="columns1" show-summary :summary-method="handleSummary1" :data="detail.incomeList" class="tables-x"  ref="selection"  no-data-text="暂无数据记录">
                                    <template #sn="{ row }">
                                        <div class="d-width text-primary cursor" :title="row.sn" @click="showIncomeData(row.id)">
                                            <span>{{row.sn}}</span>
                                        </div>
                                    </template>
                                    <template #tax_rate="{ row }">
                                        <span>{{row.tax_rate}} %</span>
                                    </template>
                                    <template #type_id="{ row }">
                                        <Tag v-if="row.type_id === 1" color="blue">{{row.type_name}}</Tag>
                                        <Tag v-else-if="row.type_id === 2" color="orange">{{row.type_name}}</Tag>
                                        <Tag v-else-if="row.type_id === 3" color="green">{{row.type_name}}</Tag>
                                        <Tag v-else-if="row.type_id === 4" color="purple">{{row.type_name}}</Tag>
                                        <span v-else>-</span>
                                    </template>
                                    <template #is_plan="{ row }">
                                        <Tag v-if="row.is_plan === 1" :color="row.plan_day <=0 && row.status !== 4 ?'red':'default'">{{row.plan_time}}</Tag>
                                        <span v-else>-</span>
                                    </template>
                                    <template #status="{ row }">
                                        <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                        <Badge v-else-if="row.status === 2" color="orange" :text="row.status_name" />
                                        <Poptip v-else-if="row.status === 4" trigger="hover" width="240" :word-wrap="true" title="到账信息：" >
                                            <Badge color="green" :text="row.status_name" />
                                            <template #content>
                                                <p style="white-space: normal;">金额：<span class="text-success">{{row.get_money}}</span></p>
                                                <p style="white-space: normal;">时间：{{row.get_date}}</p>
                                            </template>
                                        </Poptip>
                                        <Poptip v-else-if="row.status === 3" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                            <Badge color="red" :text="row.status_name" />
                                            <template #content>
                                                <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                                <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                            </template>
                                        </Poptip>
                                        <Badge v-else color="#999999" text="其他" />
                                    </template>
                                    <template #is_invoice="{ row }">
                                        <Badge v-if="row.is_invoice === 1" color="#999" :text="row.is_invoice_name" />
                                        <Badge v-else-if="row.is_invoice === 2" color="blue" :text="row.is_invoice_name" />
                                        <Badge v-else-if="row.is_invoice === 3" color="orange" :text="row.is_invoice_name" />
                                        <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
                                        <Badge v-else color="#999999" text="其他" />
                                    </template>
                                    <template #remark="{ row }">
                                        <div class="d-width" :title="row.remark">
                                            <span>{{row.remark}}</span>
                                        </div>
                                    </template>
                                    <template #action="{ row }">
                                        <a class="text-font-sm text-success" @click="showIncomeData(row.id)">查看</a>
                                    </template>
                                </Table>
                            </Description>
                        </DescriptionList>
                    </Card>

                    <Card :bordered="false" dis-hover>
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> <strong class="text-primary">发票记录</strong></template>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="">
                                <Table :stripe="true" border  size="small" :columns="columns2" show-summary :summary-method="handleSummary2" :data="detail.invoiceList" class="tables-x"  ref="selection"  no-data-text="暂无数据记录">
                                    <template #inv_money="{ row }">
                                        <div class="d-width" :title="row.inv_money">
                                            <span>{{row.inv_money}}</span>
                                        </div>
                                    </template>
                                    <template #get_money="{ row }">
                                        <span>{{row.get_money??'0.00'}}</span>
                                    </template>
                                    <template #get_bank="{ row }">
                                        <div class="d-width" :title="row.get_bank_name">
                                            <span>{{row.get_bank_name??'-'}}</span>
                                        </div>
                                    </template>
                                    <template #get_date="{ row }">
                                        <div class="d-width" :title="row.get_date">
                                            <span>{{row.get_date??'-'}}</span>
                                        </div>
                                    </template>
                                    <template #inv_type="{ row }">
                                        <Tag>{{row.inv_type_name}}</Tag>
                                    </template>
                                    <template #inv_head="{ row }">
                                        <div class="d-width" :title="row.inv_head">
                                            <span>{{row.inv_head}}</span>
                                        </div>
                                    </template>
                                    <template #inv_num="{ row }">
                                        <div class="d-width" :title="row.inv_num">
                                            <span>{{row.inv_num}}</span>
                                        </div>
                                    </template>
                                    <template #inv_bank="{ row }">
                                        <div class="d-width" :title="row.inv_bank">
                                            <span>{{row.inv_bank}}</span>
                                        </div>
                                    </template>
                                    <template #inv_address="{ row }">
                                        <div class="d-width" :title="row.inv_address">
                                            <span>{{row.inv_address}}</span>
                                        </div>
                                    </template>
                                    <template #status="{ row }">
                                        <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                        <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                            <Badge color="red" :text="row.status_name" />
                                            <template #content>
                                                <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                                <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                            </template>
                                        </Poptip>
                                        <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                        <Badge v-else color="#999999" text="其他" />
                                    </template>
                                    <template #remark="{ row }">
                                        <div class="d-width" :title="row.remark">
                                            <span>{{row.remark}}</span>
                                        </div>
                                    </template>
                                    <template #action="{ row }">
                                        <a class="text-font-sm text-success" @click="showInvoiceData(row.inv_id)">查看</a>
                                    </template>
                                </Table>
                            </Description>
                        </DescriptionList>
                    </Card>

                </Col>
            </Row>
            <div class="box-drawer-footer center" v-if="(detail.status > 0 && detail.status !== 13) || (detail.status > 0 && detail.status !== 13) || detail.status < 0">
                <Button class="mr10" v-if="detail.status > 0 && detail.status !== 13" @click="setData(detail.project_id,1)">项目取消</Button>
                <Button class="mr10" v-if="detail.status > 0 && detail.status !== 13" type="warning" ghost @click="setData(detail.project_id,2)">项目暂停</Button>
                <Button class="mr10" v-if="detail.status < 0" type="success" ghost @click="setData(detail.project_id,3)">项目开启</Button>
            </div>
        </div>

        <!-- 收款详情  -->
        <show-income-modal v-if="is_income_show" ref="ShowIncomeRef"></show-income-modal>

        <!-- 项目支出详情  -->
        <show-expend-modal v-if="is_expend_show" ref="ShowExpendRef"></show-expend-modal>

        <!-- 发票详情  -->
        <show-invoice-modal v-if="is_invoice_show" ref="ShowInvoiceRef"></show-invoice-modal>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>
    </Drawer>
</template>

<script>

import {setDataProject, getProjectShow} from "@/apis/project";
import ShowIncomeModal from "@/view/income/Show";
import ShowExpendModal from "@/view/expend/Show";
import ShowInvoiceModal from "@/view/invoice/Show";

export default {
    name: 'ProjectShow',
    components: {
        ShowExpendModal, ShowIncomeModal, ShowInvoiceModal
    },
    data () {
        return {
            title: '项目详情',
            detail: [],
            isBox: false,
            site_url: this.$siteApi,
            is_view_box: false,
            view_url: '',
            is_income_show: false,
            is_expend_show: false,
            is_invoice_show: false,

            columns: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    width : 150
                },
                {
                    title: '支出信息',
                    key: 'buyer_id',
                    slot: 'buyer_id',
                },
                {
                    title: '支出金额',
                    key: 'money'
                },
                {
                    title: '支出类型',
                    key: 'type_id',
                    slot: 'type_id'
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '付款时间',
                    key: 'pay_time',
                    slot: 'pay_time',
                },
                {
                    title: '供应商',
                    key: 'company',
                    slot: 'company',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark'
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 70
                }
            ],
            columns1:[
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    width : 150
                },
                {
                    title: '金额',
                    key: 'money',
                },
                {
                    title: '费率',
                    key: 'tax_rate',
                    slot: 'tax_rate'
                },
                {
                    title: '税费',
                    key: 'tax_money',
                },
                {
                    title: '实收',
                    key: 'true_money',
                },
                {
                    title: '类型',
                    key: 'type_id',
                    slot: 'type_id',
                },
                {
                    title: '计划收款',
                    key: 'is_plan',
                    slot: 'is_plan',
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '发票',
                    key: 'is_invoice',
                    slot: 'is_invoice',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark'
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 70
                }
            ],
            columns2:[
                {
                    title: '发票类型',
                    key: 'inv_type',
                    slot: 'inv_type'
                },
                {
                    title: '开票金额',
                    key: 'inv_money',
                    slot: 'inv_money',
                },
                {
                    title: '到账金额',
                    key: 'get_money',
                    slot: 'get_money',
                },
                {
                    title: '到账银行',
                    key: 'get_bank',
                    slot: 'get_bank',
                },
                {
                    title: '到账时间',
                    key: 'get_date',
                    slot: 'get_date',
                },

                {
                    title: '发票抬头',
                    key: 'inv_head',
                    slot: 'inv_head',
                },
                {
                    title: '发票税号',
                    key: 'inv_num',
                    slot: 'inv_num',
                },
                {
                    title: '发票银行',
                    key: 'inv_bank',
                    slot: 'inv_bank',
                },
                {
                    title: '发票地址',
                    key: 'inv_address',
                    slot: 'inv_address',
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 70
                }
            ],
            columns3:[
                {
                    title: '类型',
                    key: 'type_name'
                },
                {
                    title: '金额',
                    key: 'money'
                },
                {
                    title: '总审计金额',
                    key: 'total_money'
                },
                {
                    title: '项目总审计金额',
                    key: 'project_money'
                },
                {
                    title: '审计公司',
                    key: 'audit_company'
                },

                {
                    title: '审计时间',
                    key: 'audit_time'
                }
            ]

        }
    },
    methods: {
        /**
         功能：
         time: 2026/1/7 10:35
         **/
        showInvoiceData(inv_id){
            let that = this;
            that.is_invoice_show = true;
            setTimeout(function(){
                that.$refs.ShowInvoiceRef.show(inv_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showIncomeData(id){
            let that = this;
            that.is_income_show = true;
            setTimeout(function(){
                that.$refs.ShowIncomeRef.show(id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showExpendData(expend_id){
            let that = this;
            that.is_expend_show = true;
            setTimeout(function(){
                that.$refs.ShowExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 17:56
         **/
        setData(project_id, status){
            let that = this;
            if(!project_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            var text = "此操作将取消项目, 是否继续?";
            if(status === 2){
                text = "此操作将暂停项目, 是否继续?";
            }else if(status === 3){
                text = "此操作将开启项目, 是否继续?";
            }
            that.$Modal.confirm({
                title: '提示信息',
                content: text,
                onOk: () => {
                    setDataProject(project_id, status).then( () =>{
                        that.$Message.success({ background: true,duration:3, content:'操作成功'});
                        that.GetDetail(project_id);
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：
         time: 2026/1/6 17:57
         **/
        handleSummary ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 2){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },
        /**
         功能：
         time: 2026/1/6 17:57
         **/
        handleSummary1 ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 1 || index === 3 || index === 4){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },
        /**
         功能：
         time: 2026/1/6 17:57
         **/
        handleSummary2 ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 1 || index === 2){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },
        /**
         功能：
         time: 2026/1/4 16:31
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectShow(id).then(e => {
                that.detail = e.data;
                that.title = e.data.name + " - 项目详情";
            })
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        show(project_id){
            this.isBox = true;
            if(project_id) this.GetDetail(project_id);
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目详情';
            this.detail =  [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
